export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const MY = "club_my_token";
export const getMyToken = () => { try { return localStorage.getItem(MY) || ""; } catch { return ""; } };
export const setMyToken = (t) => { try { localStorage.setItem(MY, t); } catch {} };
export const clearMyToken = () => { try { localStorage.removeItem(MY); } catch {} };
